import React from "react";

const SandClockSVG = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.869019" width="28" height="28" rx="4" fill="#F5F7FF" />
      <path
        d="M9.33398 21.5356H18.6673"
        stroke="#6570FC"
        strokeWidth="0.866667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33398 8.20239H18.6673"
        stroke="#6570FC"
        strokeWidth="0.866667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3327 21.5357V18.7544C17.3326 18.4008 17.1921 18.0617 16.942 17.8117L13.9993 14.869L11.0567 17.8117C10.8066 18.0617 10.6661 18.4008 10.666 18.7544V21.5357"
        stroke="#6570FC"
        strokeWidth="0.866667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.666 8.20239V10.9837C10.6661 11.3373 10.8066 11.6764 11.0567 11.9264L13.9993 14.8691L16.942 11.9264C17.1921 11.6764 17.3326 11.3373 17.3327 10.9837V8.20239"
        stroke="#6570FC"
        strokeWidth="0.866667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SandClockSVG;
